import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { GetUserVideo, getVideo } from './../../s3Func/s3Download'
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat'
import './DistancePractice.scss'
import { API } from 'aws-amplify'
import { sleep } from '../../utils/index'
import MediaService from '../../services/MediaService'

const DistancePractice = (props) => {
	const { login } = useSelector((state) => state.loginReducer, shallowEqual)

	// Initialize variables to be used later
	const dispatch = useDispatch()
	const [practiceVideo, setPracticeVideo] = useState(false)
	const [practice, setPractice] = useState(false)
	const [displayPracticeVideo, setDisplayPracticeVideo] = useState()
	const [score, setScore] = useState(0)
	const [tryAgainAnimation, setTryAgainAnimation] = useState(false)
	const [amazingJobAnimation, setAmazingJobAnimation] = useState(false)
	const [playIntro, setPlayIntro] = useState(false)
	const [introAudio, setIntroAudio] = useState('')
	const [birdAudio, setBirdAudio] = useState('')
	const [tryAgain, setTryAgain] = useState('')
	const [amazingJob, setAmazingJob] = useState('')
	const [dingAudio, setDingAudio] = useState('')
	const [point, setPoint] = useState(0)
	const [photoNum, setPhotoNum] = useState(null)

	const birdAudioRef = useRef(null)
	const dingAudioRef = useRef(null)
	const expectedBirdSrcRef = useRef('')

	const bird = MediaService.getImage('/Module5Images/practice/Bird_BodyOnly_Side.png', login)
	const head = MediaService.getImage('/Module5Images/practice/Bird_Head_Side.png', login)
	const wing = MediaService.getImage('/Module5Images/practice/Bird_Wing.png', login)
	const highlight = MediaService.getImage('/Module5Images/practice/Bird_Wing_Outline.png', login)
	const faceTryAgain = MediaService.getImage('/Module5Images/practice/bird-head-try-again.gif', login)
	const faceAmazingJob = MediaService.getImage('/Module5Images/practice/bird-head-amazing-job.gif', login)
	const closeBtnImage = MediaService.getImage('/Images/close.png', login)

	const images = useMemo(
		() => [
			'', // index 0
			'appfiles/distance/day-1-kate-power.jpg', // day 1
			'appfiles/distance/day-2-kamden-power.jpg', // day 2
			'appfiles/distance/day-3-ryker-power.jpg', // day 3
			'', // day 4, no photo
			'appfiles/distance/day-3-ryker-power.jpg', // day 5
			'appfiles/distance/day-2-kamden-power.jpg', // day 6
			'appfiles/distance/day-1-kate-power.jpg', // day 7
			'appfiles/distance/day-3-ryker-power.jpg', // day 8
			'appfiles/distance/day-2-kamden-power.jpg', // day 9
		],
		[]
	)

	const loadData = useCallback(async () => {
		const selectedPhoto = await getVideo(images[props.module.currentday], login)
		setPhotoNum(selectedPhoto)
		const amazingJobAudio = await getVideo(
			'appfiles/distance/practice_amazing_job.mp3', login
		)
		setAmazingJob(amazingJobAudio)
		const tryAgainAudio = await getVideo(
			'appfiles/distance/practice_try_again.mp3', login
		)
		setTryAgain(tryAgainAudio)

		const dingSound = MediaService.getVideo(
			'/Module1Videos/button_accept_item.mp3',
			login
		)
		setDingAudio(dingSound)
	}, [images, props.module.currentday, login])

	const getPracticeVideo = useCallback(async () => {
		let video = ''
		const module10Completed =
			props.stepComplete === 'MODULE10_SET_stepCompleted'

		if (!props.unit4) {
			if (props.module.currentday === 1) {
				video = module10Completed
					? MediaService.getVideo('/Module10/practice_day_1.mp4', login)
					: MediaService.getVideo('/Module5Videos/practice_day_1.mp4', login)
			}

			if (props.module.currentday === 2) {
				video = module10Completed
					? MediaService.getVideo('/Module10/practice_day_2.mp4', login)
					: MediaService.getVideo('/Module5Videos/practice_day_2.mp4', login)
			}

			if (props.module.currentday === 3) {
				video = module10Completed
					? MediaService.getVideo('/Module10/practice_day_3.mp4', login)
					: MediaService.getVideo('/Module5Videos/practice_day_3.mp4', login)
			}

			if (props.module.currentday > 3) {
				video = await GetUserVideo(
					`influencers/${login.influencerid}/distance_video_message.mp4`
				)
			}
			setDisplayPracticeVideo(video)
			setPracticeVideo(true)
		} else {
			setIntroAudio(getVideo('appfiles/distance/practice_intro.mp3', login))
			setPlayIntro(true)
			setPractice(true)
		}
	}, [])

	// Decide which video to play for practice based on the day
	useEffect(() => {
		loadData()
		getPracticeVideo()
	}, [])

	// Decide if the bird has been dragged to the correct distance and if it has then highlight it
	const handleChange = (event, newValue) => {
		setPlayIntro(false)
		setScore(event.target.value)
		if (event.target.value > 120 && event.target.value < 130) {
			// document.getElementById('highlight').style.opacity = 1
			// document.getElementById('wing').style.opacity = '0.9'
			document.getElementById('wing').style.animationDuration = '1s'
		} else {
			// document.getElementById('highlight').style.opacity = 0
			// document.getElementById('wing').style.opacity = '1'
			document.getElementById('wing').style.animationDuration = '0s'
		}
	}

	const handlePracticeEnded = async () => {
		try {
			await API.post('TIR', '/v3/student/result', {
				body: {
					student_id: login.studentid,
					metric: 'practice_distance',
					result: JSON.stringify({
						day: module.currentday,
						created: new Date().toISOString(),
						review: props.unit2 ? 1 : 0,
						values: [
							{
								value: 1 + point,
								target: 1,
							},
						],
					}),
				},
			})
		} catch (error) {
			console.log(error)
		}
		setAmazingJobAnimation(false)
		if (!props.unit4) {
			if (!props.module.reviewIcon) {
				dispatch({ type: props.stepComplete, payload: 'practice' })
			}
		} else {
			props.next()
		}
		props.module.sectionCompleted = props.module.sectionCompleted + 1
		props.setDisplayPractice(false)
		setAmazingJobAnimation(false)
	}

	// If the bird has been dragged the correct distance, set the bird to talk to the user and move on.
	const checkScore = async () => {
		const el = birdAudioRef.current
		const isSuccess = score > 120 && score < 130
		if (isSuccess)  {
			// For success path, if any audio is currently playing, ignore to avoid overlap
			if ((dingAudioRef.current && !dingAudioRef.current.paused) || (el && !el.paused)) {
				return
			}
			try {
				if (dingAudioRef.current) {
					dingAudioRef.current.currentTime = 0
					await dingAudioRef.current.play()
				}
			} catch (error) {
				// no-op: iOS may still block if not from a gesture
			}
		} else {
			if (score < 10) return;
			setPoint(-1)
			setTryAgainAnimation(true)
			const currentSrc = el ? (el.currentSrc || el.src) : ''
			const sameSrc = currentSrc && currentSrc.includes(tryAgain)
			expectedBirdSrcRef.current = tryAgain
			if (el) {
				try {
					// Always restart the tryAgain audio, even if it's currently playing
					el.pause()
					el.currentTime = 0
					if (sameSrc) {
						await el.play()
					} else {
						setBirdAudio(tryAgain)
					}
				} catch (e) {
					// ignore
				}
			} else {
				// Fallback if ref missing
				setBirdAudio(tryAgain)
			}
		}
	}

	// The HTML code for practice.
	return (
		<>
			{practiceVideo && (
				<CloudfrontVideoFormat
					source={displayPracticeVideo}
					back="/distance"
					close={props.setDisplayPractice}
					background={props.background}
					ended={() => {
						setPracticeVideo(false)
						setPractice(true)
						if (props.unit2) {
							setIntroAudio(getVideo('appfiles/distance/review_practice_intro.mp3', login))
							setPlayIntro(true)
						} else {
							setIntroAudio(getVideo('appfiles/distance/practice_intro.mp3', login))
							setPlayIntro(true)
						}
					}}
				/>
			)}

			{playIntro && (
				<audio autoPlay onEnded={() => setPlayIntro(false)}>
					<source src={introAudio} type="audio/mp3" />
				</audio>
			)}

			{/* Always-mounted audio elements for reliable iOS playback */}
			<audio
				ref={birdAudioRef}
				src={birdAudio}
				preload="auto"
				playsInline
				onLoadedData={() => {
					const el = birdAudioRef.current
					if (!el) return
					const expected = expectedBirdSrcRef.current
					const currentSrc = el.currentSrc || el.src
					if (!expected || (currentSrc && !currentSrc.includes(expected))) return
					el.currentTime = 0
					el.play().catch((e) => {
						const msg = String(e && e.message ? e.message : e)
						if (!msg.includes('interrupted by a new load request')) {
							console.log('bird audio play failed', e)
						}
					})
				}}
				onEnded={() => {
					setTryAgainAnimation(false)
					if (birdAudio === amazingJob) {
						handlePracticeEnded()
					}
				}}
			/>

			<audio
				ref={dingAudioRef}
				src={dingAudio}
				preload="auto"
				playsInline
				onEnded={() => {
					expectedBirdSrcRef.current = amazingJob
					setBirdAudio(amazingJob)
					setAmazingJobAnimation(true)
				}}
			/>

			{practice && (
				<div
					className="DistancePractice"
					style={{ backgroundImage: `url(${props.background})` }}
				>
					<header>
						<h1>Help the bird be at arm&apos;s length<br/><h2>(Drag the slide bar until the bird's wing glows)</h2></h1>
						<button
							className="close-btn"
							onClick={() => props.setDisplayPractice(false)}
						>
							<img src={closeBtnImage} alt="close button" />
						</button>
					</header>

					<main>
						<div
							className="photo-container"
							style={{ backgroundImage: `url(${photoNum})` }}
						></div>
						<div className="bird-container">
							<figure style={{ paddingLeft: `${20 + score / 10}%` }}>
								<img alt="" id="body" className="body" src={bird} />
								<img
									id="wing"
									alt=""
									className="wing"
									style={{
										transform: `rotate(${score * 1.2}deg)`,
										transformOrigin: 'top left',
									}}
									src={wing}
								/>

								<div id="head">
									<img
										alt=""
										className="head--facing-forward"
										src={head}
										style={{
											opacity:
												!amazingJobAnimation && !tryAgainAnimation ? 1 : 0,
										}}
									/>
									<img
										className="head--try-again"
										alt=""
										src={faceTryAgain}
										style={{
											opacity: tryAgainAnimation ? 1 : 0,
										}}
									/>
									<img
										className="head--amazing-job"
										alt=""
										src={faceAmazingJob}
										style={{
											opacity: amazingJobAnimation ? 1 : 0,
										}}
									/>
								</div>

								<img
									alt=""
									className="highlight"
									id="highlight"
									src={highlight}
								/>
							</figure>
						</div>
					</main>

					<div className='slider-container'>
						<input
							type="range"
							min="0"
							max="145"
							value={score}
							className="slider"
							id="myRange"
							onPointerUp={checkScore}
							onMouseUp={checkScore}
							onTouchEnd={checkScore}
							onChange={handleChange}
						/>
					</div>
				</div>
			)}
		</>
	)
}
export default DistancePractice
